"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'register.company.checkbox_label': 'Registrati con azienda',
    'register.company.form_title': 'Informazioni azienda',
    'register.company.section_title': 'Informazioni azienda (Opzionale)',
    'register.company.add_button': 'Aggiungi azienda',
    'register.company.data_added': 'Dati azienda aggiunti con successo',
    'register.company.remove_button': 'Rimuovi azienda',
    'register.company.optional_help': 'Puoi opzionalmente aggiungere le informazioni della tua azienda durante la registrazione',
    'register.company.removed': 'Dati azienda rimossi con successo',
};
